import React from "react";
import PremiumHero from "../components/common/PremiumHero";

const Section = ({ title, children }) => (
  <div className="bg-white border rounded-2xl p-6">
    <h3 className="text-lg font-bold text-gray-900 mb-3">{title}</h3>
    <div className="text-gray-700 leading-relaxed text-sm space-y-3">
      {children}
    </div>
  </div>
);

export default function CGV() {
  return (
    <div className="bg-white">
      <PremiumHero
        title="Conditions Générales de Vente (CGV)"
        subtitle="Maxula S.A.R.L — Transparence, sécurité et cadre légal"
      />

      <section className="py-14 bg-[#fff3f8]">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 space-y-6">
          <div className="bg-white border rounded-2xl p-6 text-gray-700">
            <div className="font-bold text-gray-900">Maxula S.A.R.L</div>
            <div className="text-sm mt-2">
              RC : 75375 — Identifiant fiscal : 18766346 — Patente : 50489114 — ICE : 001588644000012
              <br />
              Siège : Avenue Beethoven, Résidence Oumnia 1, Bureau 83, Tanger – Maroc
              <br />
              Email : contact@maxula.ma
            </div>
          </div>

          <Section title="1. Objet des CGV">
            <p>
              Les présentes CGV définissent les droits et obligations entre Maxula S.A.R.L et ses clients concernant l’utilisation :
              Maxula Experiences, Maxula Laser Clinic, Maxula House.
            </p>
            <p>
              L’utilisation du site Maxula.ma et/ou l’achat d’un service implique l’acceptation sans réserve des présentes CGV.
            </p>
          </Section>

          <Section title="2. Services proposés">
            <p><b>2.1 Maxula Experiences</b> : Maxula agit exclusivement en tant qu’intermédiaire entre les clients et les partenaires. La prestation est réalisée par le partenaire, seul responsable.</p>
            <p><b>2.2 Maxula Laser Clinic</b> : Maxula agit uniquement en intermédiaire. Maxula ne réalise aucune séance, ne garantit aucun résultat, et n’est pas responsable des incidents du centre partenaire.</p>
            <p><b>2.3 Maxula House</b> : Maxula House intervient comme intermédiaire pour location/vente/recherche/services VIP. Maxula n’est pas responsable de l’état réel du bien ni des litiges entre parties.</p>
          </Section>

          <Section title="3. Prix et moyens de paiement">
            <ul className="list-disc list-inside space-y-1">
              <li>Lien de paiement sécurisé CMI</li>
              <li>Paiement en espèces dans nos bureaux</li>
              <li>TPE / carte bancaire dans nos bureaux</li>
              <li>Virement bancaire (si applicable)</li>
            </ul>
            <p className="text-xs text-gray-500">
              Aucun paiement direct ne doit être effectué chez le prestataire.
            </p>
          </Section>

          <Section title="4. Coupons et validité">
            <ul className="list-disc list-inside space-y-1">
              <li>Date de validité indiquée</li>
              <li>Utilisation avant expiration</li>
              <li>Non remboursables / non échangeables sauf cas exceptionnel</li>
            </ul>
            <p>En cas de retard/absence, la prestation peut être considérée comme consommée.</p>
          </Section>

          <Section title="5. Annulation et remboursement">
            <p><b>Experiences</b> : pas de remboursement sauf annulation définitive du partenaire ou erreur technique prouvée.</p>
            <p><b>Laser Clinic</b> : séances déjà réalisées non remboursables. Remboursement possible uniquement des séances restantes avec retenue de 30% (virement, 30–45 jours).</p>
            <p><b>House</b> : honoraires dus à la signature (compromis/acte). Pas de remboursement sauf faute avérée.</p>
          </Section>

          <Section title="6. Responsabilité">
            <p>Chaque partenaire est seul responsable de ses services. Maxula décline toute responsabilité pour incidents et litiges.</p>
          </Section>

          <Section title="7. Données personnelles & propriété intellectuelle">
            <p>Maxula respecte la loi marocaine sur la protection des données. Le client peut demander suppression de ses informations.</p>
            <p>Tout contenu Maxula.ma est protégé. Reproduction interdite sans autorisation.</p>
          </Section>

          <Section title="8. Loi applicable">
            <p>Les CGV sont régies par la loi marocaine. Tribunaux de Tanger compétents.</p>
          </Section>
        </div>
      </section>
    </div>
  );
}
